import React from "react";

const CircleLoading = ({className}) => {
  
  return (
    <div className="spinner-box">
      <div className={`${className} three-quarter-spinner`}></div>
    </div>
  );
};

export default CircleLoading;
